// Rhythm data for one 8-count phrase. Counts run 1..8 and may be half-counts
// (2.5 is "2&"). Pinned by test/patterns.test.ts; change them only with a test.

export type ClaveDirection = '3-2' | '2-3';

/** What the dancer (or the clave evidence) says about the clave: a direction, or not known. */
export type ClaveSetting = ClaveDirection | 'unknown';

/** Son clave, one phrase: 3-2 = 1, 2&, 4, 6, 7; 2-3 = 2, 3, 5, 6&, 8. */
export const CLAVE: Readonly<Record<ClaveDirection, readonly number[]>> = {
  '3-2': [1, 2.5, 4, 6, 7],
  '2-3': [2, 3, 5, 6.5, 8],
};

/** Dancer steps in one phrase (the counts that carry a step). */
export const DANCER_STEPS: readonly number[] = [1, 2, 3, 5, 6, 7];

/** Beats in one phrase. Taps are 1s, so consecutive taps are one phrase apart. */
export const PHRASE_BEATS = 8;
